var checkbox_products_set = false;
/***************************************************** */
/** Cart Drawer and Checkout upsell products settings */
/****************************************************** */
/** Text for buttons */
var remove_product_text = 'Remove';
var added_product_text = 'Added';
var add_to_cart_text = 'Add to Cart';
/** Number of Variants to be displayed */
var max_options = 999;

/** Cart Drawer upsell products */
var featured_products = [];
featured_products.push('example-product');
// featured_products.push('elliston-leather-axel-card-holder1');

/** Checkout upsell products */
var bundle_products = [];
bundle_products.push('example-product');
// bundle_products.push('elliston-leather-defiance-leather-jacket1');

/** Cart Drawer rush my order & package protection or any other product (use variants) */
var checkbox_products = []; 
 checkbox_products.push('47066510786878');
 checkbox_products.push('47066527760702'); //rush my order

//checkbox_products.push(package_production_product); //package protection
/** Automatically adding of products in the */
// var auto_add_checkbox_products = true;
// var auto_add_product = [];
// auto_add_product.push(rush_my_order_product);
// auto_add_product.push(package_production_product);
var auto_add_checkbox_products = false; //if need to auto add these products

/*******************************/
/** Events Callbacks **/
/******************************/
const vip_guest_buttons_required=true;
const vip_guest_buttons_terms_text="By purchasing this offer, you acknowledge that you have read and agreed to our website Terms of Service and billing terms. This offer is only valid for people in our VIP Membership program. If you are a first time buyer, you will be charged 29.99 dollars each month. Cancel anytime. If you want to pay full price and not enroll in any membership, please click the Guest Add to Cart Button below or at the bottom of this page."; 

var button_type_clicked = "";
$(window).on("pageshow", function (event) {
  updateCartDrawer(0, 0);
  if(page.url != "/pages/checkout-3"){
    clearGuestProduct();
  }
});


$('body').on('click','.crm_drawer__close-button',function(){
  $("#crm_drawer").removeClass('open'); 
  $("#crm_overlay_side").css('display','none')
});

$("#crm_overlay_side").click(function(){
  $("#crm_drawer").removeClass('open'); 
  $("#crm_overlay_side").css('display','none')
});


$(document).ready(function () {

  const elements = document.querySelectorAll('.product-form__input--pill');

    if (elements.length > 0) {
        elements[elements.length - 1].classList.add('hidden');
      }


  $('body').on('click','.crm_drawer__close-button',function(){
    $("#crm_drawer").removeClass('open'); 
    $("#crm_overlay_side").css('display','none')
  });
  
  $("#crm_overlay_side").click(function(){
    $("#crm_drawer").removeClass('open'); 
    $("#crm_overlay_side").css('display','none')
  });

  setTimeout(function () {
    checkBundleExists();
  }, 1000);

  vip_guest_buttons(vip_guest_buttons_required);

   /* VIP/Guest Button script */
  $('body').on('click', '.user_add_to_cart', function (e) {
    e.preventDefault();
    var user_type = e.currentTarget.dataset.addtocart;
    
    //$('input[type=radio][value="Guest Price"]').prop('checked', true);
    var radios = $('input[type="radio"]'); 
    for (i = 0; i < radios.length; i++) {
     
      
      if (radios[i].value == e.currentTarget.dataset.addtocart) {
        console.log('vip ',radios[i].value , e.currentTarget.dataset.addtocart)
        radios[i].click();
      }
    }
    
    $('input[type=radio][value="'+user_type+'"]').prop('checked', true);
    
    // $('.select__select').val(e.currentTarget.dataset.addtocart).trigger('change');
    // var user_type =  $('.select__select').val();
    if (user_type == 'VIP Price') {
      button_type_clicked = "VIP";

      addProductToCart();
    } else {
      button_type_clicked = "Guest";

      guest_add_to_cart();

      return false;
      $('.atc-button').trigger('click');
      // addToCartFunction_CRM_drawer(variant_id, qty, stop_next = 0)
      console.log('Guest add to carthere else');
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function (cart) {
          Shopify.queue = [];
          $.each(cart.items, function (index, item) {
            Shopify.queue.push({
              variantId: item.variant_id,
            });
          });
          Shopify.moveAlong = function () {
            // If we still have requests in the queue, let's process the next one.                      
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var data = 'id=' + request.variantId + '&quantity=0'
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: data,
                success: function (res) {
                  Shopify.moveAlong();
                },
              });
            } else if (Shopify.queue.length == 0) {
              auto_add_checkbox_products = false;
             
                $('.atc-button').trigger('click');
           
             
            }
          };
          Shopify.moveAlong();
        }
      });
    }
  });

 
  /** Add to cart button functionlity */
  $('body').on('click', '.atc-button', function (e) {
    e.preventDefault();
    addProductToCart();
  });

  /** Open Cart Drawer button functionlity */
  $('body').on('click', '#cart-icon', function (e) {
    e.preventDefault();
    toggleDrawer();
  });

  //** Placing Add to Cart Button */
  setTimeout(function () {
    $('<button/>', {
      text: 'Add to Cart',
      class: 'button btn-100 new-form-atc',
      id: 'new-form-atc2',
      click: function () {
        var variant_id = 0;
        var selectedId = $('#new-form').find('.selectedWB').attr('id');
        if (typeof selectedId !== 'undefined') {
          // If the id attribute exists, perform the replace operation
          var variant_id = selectedId.replace("id", "");
        }
        if (variant_id > 0) {
          addToCartFunction_CRM_drawer(variant_id, 1);
        }
      }
    }).insertAfter('#new-form');
  }, 1500);

});

//Add VIP/Guest buttons if needed
function vip_guest_buttons(vip_guest_buttons_required)
{


  if(!vip_guest_buttons_required)
    {
      return false;
      }

   

  var radios = $('input[type="radio"]');

  if (radios.length == 0) {
      
    $('.atc-button').show(); 
    // $(".user_add_to_cart").hide();
    // $(".vip_guest_text").hide();
  } else {
    
    // // Get all elements with the specified classes product-form__input--pill
    // var elements = document.querySelectorAll('.product-form__input--pills');
    // // Loop through each element
    // elements.forEach(function (element) {
    //   // Check if the element's text content contains "VIP Price"
    //   if (element.textContent.includes("VIP Price")) {
    //     // Hide the element
    //     element.style.display = 'none';
    //   }
    // });

    // $("#ProductSubmitButton-template--17117686628399__main").hide();
    //  $(".product-form__input--pill").hide();
    // $('.atc-button').hide();
    
    

    var vip_buttons = `<div style="display:block; margin-top:30px"> <button  
    data-addtocart="VIP Price"
    class="product-form__submit button button--full-width button--margin-x user_add_to_cart vip vip_product_btn" 
    <span data-add-to-cart-text data-default-text=" ADD TO CART">
     VIP ADD TO CART
    </span>
  </button>
  <div class="vip_guest_text" style="font-weight:normal;padding-top:10px;padding-bottom:10px; font-size:10px;">
  ` +vip_guest_buttons_terms_text + ` 
      </div>
  <button
    data-addtocart="Guest Price"
    class="product-form__submit desktop_view_only button button--full-width button--margin-x  user_add_to_cart  desktop_view"
    <span data-add-to-cart-text data-default-text="GUEST ADD TO CART (PAY FULL PRICE)">
      GUEST ADD TO CART (PAY FULL PRICE)
    </span>
  </button></div>`;


    $('.product-form__submit').after(vip_buttons);

    var mobile_guest_buttons = `<div class="mobile-guest-container" style="display:none;">
  <button
  data-addtocart="Guest Price"
  class="product-form__submit mobile_view_only button button--full-width button--margin-x  user_add_to_cart guest_product_btn desktop_view"
  <span data-add-to-cart-text data-default-text="GUEST ADD TO CART (PAY FULL PRICE)">
    GUEST ADD TO CART (PAY FULL PRICE)
  </span>
</button>
  </div>
`;
$('.product__description').after(vip_buttons);

    
    // $(".user_add_to_cart").show();
    // $(".vip_guest_text").show();
  }
}



/** For Cart Drawer upsell products */
$(document).on('click', '.featured_products_btn', function () {
  var value = $.trim($(this).find('span').text());
  if (value != added_product_text) {
    custom_add_remove_with_handle_new($(this).attr('product'), 1);
    $(this).addClass('in_cart');
    $(this).find('span').text(added_product_text);
  } else {
    custom_add_remove_with_handle_new($(this).attr('product'), 0);
    $(this).removeClass('in_cart');
    $(this).find('span').text(add_to_cart_text);
  }
});

/** For Checkout upsell products */
$(document).on('click', '.bundle_products_btn', function (event) {
  event.stopPropagation();
  var value = $.trim($(this).find('span').text());
  var handle = $(this).attr('product');
  if (value != remove_product_text) {
    custom_add_remove_with_handle_new(handle, 1);
    $(this).addClass('in_cart');
    $(this).find('span').text(remove_product_text);
    $('.main_' + handle).addClass('blue_bg');
  } else {
    custom_add_remove_with_handle_new(handle, 0);
    $('#' + handle + '_r').prop('checked', false);
    $('.' + handle).hide("slow");
    $(this).removeClass('in_cart');
    $(this).find('span').text(add_to_cart_text);
    $('.main_' + handle).removeClass('blue_bg');
  }
  loadCart();
  refresh_price();
});

/** For checkbox click event trigger from checkout upsell product */
$(document).on('click', '.promo_1', function () {
  if (!$(this).find('.featured_products_checkbox2').is(":checked")) {
    $(this).find('.featured_products_checkbox2').prop("checked", true);
    checkbox_clicked($(this).find('.featured_products_checkbox2'));
  }
});

$(document).on('click', '.featured_products_checkbox2', function (event) {
  event.stopPropagation();
  checkbox_clicked(this);
});

/**************************** */

// Call updateCartDrawer function when the cart drawer is opened
$('#YourCartDrawerToggleButton').on('click', function () {
  updateCartDrawer();
});


/************************************* */
/** Internal Functions */
/************************************* */
function checkbox_clicked(this_ref) {
  var checkbox_status = $(this_ref).is(":checked");
  if (!checkbox_status) {
    var handle = $(this_ref).val();
    $('.' + handle).hide("slow");
    var value = $.trim($('#c_' + handle).find('span').text());
    if (value != remove_product_text) {
      // $('#c_' + handle).addClass('in_cart');
      // $('#c_' + handle).find('span').text(remove_product_text);
    } else {
      $('#c_' + handle).removeClass('in_cart');
      $('#c_' + handle).find('span').text(add_to_cart_text);
      $('.main_' + handle).removeClass('blue_bg');
      custom_add_remove_with_handle_new(handle, 0);
      loadCart();
      refresh_price();
    }
  } else {
    var handle = $(this_ref).val();
    //$('.white_bg').hide();
    $('.' + handle).show("slow");
  }
}
// Function to get the quantity based on the radio button's value
function getQuantityById(id) {
  // Get the JSON string from the script tag
  var jsonString = $('#kaching-bundles-deal-block-config').text();
  // Parse the JSON string
  var jsonData = JSON.parse(jsonString);
  // Find the dealBar with the matching id and return the quantity
  var quantity = 0;
  $.each(jsonData.dealBars, function (index, dealBar) {
    if (dealBar.id === id) {
      quantity = dealBar.quantity;
      return false; // Break the loop once the id is found
    }
  });
  return quantity;
}

function guest_add_to_cart(){


  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    var variant_id = $('.main-product-form').find('.product-variant-id').val();
  if (variant_id === undefined) {
    variant_id = $('input[name="id"]').val();
  }

 qty = $(".quantity__input").val();
 
    addToCartFunction_CRM_drawer(variant_id, qty, 1).then( res =>{
       window.location.href = '/pages/checkout-3'; 
      console.log(res)
    }
  )
    console.log('Cart cleared:', data);
  })
  .catch(error => {
    console.error('Error clearing cart:', error);
  });



  


}

function addProductToCart() {

  var variant_id = $('.main-product-form').find('.product-variant-id').val();
  if (variant_id === undefined) {
    variant_id = $('input[name="id"]').val();
  }
  if ($('input[name="quantity"]').length > 0) {
    // var quantity = $('input[name="quantity"]:checked').val();
    var quantity = $('input[name="quantity"]').val();
    addToCartFunction_CRM_drawer(variant_id, quantity, 0, 1);
  } else {
    addToCartFunction_CRM_drawer(variant_id, 1, 0, 1);
  }
}

function updateCartDrawer(need_toggleDrawer = 0, overlay = 1) {
  if ($('input[type="radio"][name="user type"][value="VIP Price"]').length > 0) {
    // The radio button exists, now check if it is checked
    $('input[type="radio"][name="user type"][value="VIP Price"]').click();
  }
  var total_comparable_price = 0;
  if (overlay == 1)
    $('#crm_overlay').show();
  var cart_variants = [];
  var cart_handles = [];
  var vip_count = 0;
  var guest_count = 0;
  var guest_list = [];
  $.ajax({
    url: '/cart.json',
    dataType: 'json',
    success: function (cart) {
      // Empty the current contents of the cart drawer
      $('.crm_drawer_cart_inner1').html('');
      var cartItemHtml = '';
      // Loop through each item in the cart
      $.each(cart.items, function (index, item) {
        cart_variants.push(String(item.variant_id));
        cart_handles.push(item.handle);
        if (item.title.indexOf("VIP Price") != -1) {
          vip_count++;
        } else if (item.title.indexOf("Guest Price") != -1) {
          guest_count++;
          guest_list.push(item.variant_id);
        }
        original_line_price = fetch_compare_at_price(item.handle, item.variant_id) * item.quantity;
        if (original_line_price <= 0)
          original_line_price = item.discounted_price * item.quantity;
        total_comparable_price += original_line_price;
        var in_cart = checkbox_products.indexOf(item.variant_id + '');
        if (in_cart == -1) {
          cartItemHtml += `
              <div class="cart__item" data-key="${item.key}">
                <div class="cart__image">
                  <a href="${item.url}" class="image-wrap">
                    <img src="${item.image}" alt="${item.product_title}" loading="lazy" class="image-element" style="width:100px">
                  </a>
                </div>
                <div class="cart__item-details">
                  <div class="cart__item-title">
                     <b>${item.product_title}</b>`;
          item.options_with_values.forEach(function (option) {
            if (option.value != 'Default Title')
              cartItemHtml += `<div class="cart__item--variants"><div><span>${option.name}:</span> ${option.value}</div></div>`;
          });
          //original_line_price = 0;
          cartItemHtml += `</div><div class="cart__item-sub">
                    <div class="js-qty__wrapper">
                    <input type="text"  id="qty_${item.variant_id}" class="js-qty__num" value="${item.quantity}" min="0" pattern="[0-9]*"  >
                    <button type="button" onclick="crm_update_qty('${item.variant_id}','-1')" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduce item quantity by one">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>
                        <!-- <span class="icon__fallback-text" aria-hidden="true">−</span> -->
                    </button>
                    <button type="button" onclick="crm_update_qty('${item.variant_id}','+1')" class="js-qty__adjust js-qty__adjust--plus" aria-label="Increase item quantity by one">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>
                        <!-- <span class="icon__fallback-text" aria-hidden="true">+</span> -->
                    </button>
                    </div>
                    <div class="cart__item-price-col text-right"> `;
          if (original_line_price > (item.discounted_price * item.quantity))
            cartItemHtml += `<span class="cart__price line-through">$ ${original_line_price / 100}</span><Br/> `;
          cartItemHtml += `<span class="cart__price"><b>$ ${(item.discounted_price * item.quantity) / 100}</b></span>
                    </div>
                  </div>
                </div>
              </div>
            `;
        }
      });
      console.log("guest_count", guest_count, "vip_count ", vip_count);
      if (guest_count > 0 && vip_count > 0) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function (cart) {
            Shopify.queue = [];
            $.each(cart.items, function (index, item) {
              if ($.inArray('Guest Price', item.variant_options) !== -1) {
                Shopify.queue.push({
                  variantId: item.variant_id,
                });
              }
            });
            Shopify.moveAlong = function () {
              // If we still have requests in the queue, let's process the next one.                      
              if (Shopify.queue.length) {
                var request = Shopify.queue.shift();
                var data = 'id=' + request.variantId + '&quantity=0'
                $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  dataType: 'json',
                  data: data,
                  success: function (res) {
                    Shopify.moveAlong();
                  },
                });
              } else if (Shopify.queue.length == 0) {
                updateCartDrawer(need_toggleDrawer);
                return;
              }
            };
            Shopify.moveAlong();
          }
        });
      } else {
        if (cartItemHtml == '') {
          cartItemHtml = '<i style="color:#c9c9c9;">Your cart is currently empty.</i>';
          $('.crm_drawer_cart_inner4').html('');
          $('.cart-link__bubble').removeClass('cart-link__bubble--visible');
          $('.cart-count-bubble').remove();
          // $('.crm_drawer_cart_inner3').hide();
        } else {
          var static_product = `<div class="cart__item" data-key="40878262059089:f6692a492a4e43dd5f71eea6a786bb8d">
            <div class="cart__image">
              <a href="/products/free-pdf?variant=40878262059089" class="image-wrap">
                <img src="https://cdn.shopify.com/s/files/1/0577/8397/6017/products/cover_1.png?v=1710022604" alt="Botanique Paris™ Secrets of Anti-Aging - FREE GUIDE!" loading="lazy" class="image-element" style="width:100px">
              </a>
            </div>
            <div class="cart__item-details">
              <div class="cart__item-title">
                <b>Botanique Paris™ Secrets of Anti-Aging - FREE GUIDE!</b><div class="cart__item--variants"><div><span>Title:</span> Default Title</div></div></div><div class="cart__item-sub">
                <div class="js-qty__wrapper">
                </div>
                <div class="cart__item-price-col text-right"> <span class="cart__price line-through">$j39.9</span><br> <span class="cart__price"><b>$j0</b></span>
                </div>
              </div>
            </div>
          </div>`;
          static_product = '';
          cartItemHtml += static_product;
          $('.cart-link__bubble').addClass('cart-link__bubble--visible');
          $('.crm_drawer_cart_inner3').show();
          $('.crm_drawer_cart_inner4').html('<span>Shipping, taxes, and discount codes calculated at checkout.</span><Br/>');
          $('<button/>', {
            text: 'Proceed To Checkout',
            class: 'button btn-100',
            id: 'cart__checkout_btn',
            click: function () {
              window.location.href = '/pages/checkout-single';
            }
          }).insertAfter('.crm_drawer_cart_inner4 span');
          $('#cart-icon-bubble').append(`<div class="cart-count-bubble"><span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span>
          </div>`);
        }
        $('.js-cart-count').html(cart.item_count);
        $('.crm_drawer_cart_inner1').html(cartItemHtml);
        // Update the subtotal and item count
        $('.crm_drawer_cart_inner1').attr('data-count', cart.item_count);
        $('.crm_drawer_cart_inner1').attr('data-cart-subtotal', cart.total_price);
        total_comparable_price = (total_comparable_price / 100).toFixed(2);
        var total = (cart.total_price / 100).toFixed(2);
        var total_discount = (total_comparable_price - total).toFixed(2);
        var total_section = '';
        total_section += `<div>Subtotal</div><div class="crm_sub_total">${total_comparable_price}</div>`;
        total_section += `<div>Discount</div><div class="crm_sub_total">-${total_discount}</div>`;
        total_section += `<div>Total</div><div class="crm_sub_total">${total}</div>`;
        //
        // $('.crm_sub_total').html(cart.currency + ' ' + cart.total_price / 100);
        if ($('#is_checkout_page').val() == 1) {
          $('.cart-subtotal').find('span').html(cart.currency + ' ' + cart.total_price / 100);
        }
        $('.crm_drawer_cart_inner2').html(total_section);
        var checkbox_products_html = '';
        var product_show_html = '';
        checkbox_products_set = false; /*to run all time */
        if (checkbox_products_set == false) {
          checkbox_products_set = true;
          $('.crm_drawer_cart_inner5').html('');
          if ($('#is_checkout_page').val() != 1) {
            if (featured_products.count > 0) {
              product_show_html = `<div class="frequently-box">
                <div class="mu-text-center mu-p-2 mu-font-bold mu-w-full mu-frequently-header">Special Offer</div>
                <p class="spl_off text-center">Add Now for 70% OFF</p>
                <div class="mu-frequently-body" id="mu-frequently-body">
                </div></div>
                `;
              $('.crm_drawer_cart_inner5').append(product_show_html);
              $.each(featured_products, function (index, value) {
                var product_show = fetchProductByHandle(value);
                if (product_show.id > 0) {
                  var in_cart = cart_handles.indexOf(product_show.handle);
                  product_show_html = `
              <div class="mu-border-b last:mu-border-b-0 mu-mx-2 mu-py-2 frequently-box-content  ">
              <div class="mu-flex">
                <div class="mu-rounded mu-bg-cover mu-bg-center mu-block fr-image">
                  <img  src="${product_show.featured_image}">
                </div>
                <div class=" ">
                  <b class="mu-mb-2 mu-overflow-hidden mu-w-full mu-line-clamp">
                    <a class="product_title" href="/products/${product_show.handle}">${product_show.title}</a>
                  </b>
                  <div class="btn-100" style="padding:10px 0px;"  >
                      <span class="transcy-money">${product_show.price / 100}</span>
                  </div>
                  <div class="mu-items-center mu-flex-wrap">
                    <div class="variant-selector">`;
                  var i = 0;
                  product_show.options.forEach(function (option) {
                    if (option.name != 'Title') {
                      var select = '<select id="' + product_show.handle + '_option[' + i + ']" name="' + option.name + '">';
                      var counter_print = 1;
                      option.values.forEach(function (value) {
                        if (counter_print <= max_options)
                          select += '<option value="' + value + '">' + value + '</option>';
                        counter_print++;
                      });
                      select += '</select>';
                      i++;
                      product_show_html += select;
                    }
                  });
                  product_show_html += `</div>
              <div class="variant-selector">
                    <button product="${product_show.handle}"  type="button"   class="featured_products_btn
                    `;
                  if (in_cart !== -1)
                    product_show_html += "in_cart";
                  product_show_html += `" style="font-size: 0.8em;">
                      <span class="">`;
                  if (in_cart !== -1)
                    product_show_html += added_product_text;
                  else
                    product_show_html += add_to_cart_text;
                  product_show_html += `</span>
                    </button></div>
                  </div>
                </div>
              </div>
            </div> `;
                  $('#mu-frequently-body').append(product_show_html);
                }
              });
            }
          }
          if ($('#is_checkout_page').val() == 1) {
            product_show_html = `<div class="frequently-box">
          <div class="mu-frequently-body" id="bundle_product_list_body">
        </div></div>
        `;
            $('#bundle_product_list').html(product_show_html);
            $.each(bundle_products, function (index, value) {
              var product_show = fetchProductByHandle(value);
              if (product_show.id > 0) {
                var in_cart = cart_handles.indexOf(product_show.handle);
                product_show_html = `
            <div class="promo_1 pink_bg main_${product_show.handle} `;
                if (in_cart !== -1)
                  product_show_html += "blue_bg";
                product_show_html += ` ">
            <div class="row align-items-center">
              <div class="col-1 col-md-1">
              <div class="checkbox-wrapper-13">
            <input type="checkbox" value="${product_show.handle}" id="${product_show.handle}_r"  name="checkbox_bundle"  class="featured_products_checkbox2"   ><div class="arrow_icon"><i class="fa fa-long-arrow-right" aria-hidden="true" style="position:relative;"></i></div>
            <label style="display:none;" class="checkbox style-d" for="${product_show.handle}_r"></label>
        </div>
              </div>
              <div class="col-3 col-md-2">
                  <img  src="${product_show.featured_image}" width="83">
              </div>
              <div class="col-7 col-md-9">
                <div class="row align-items-center">
                  <div class="col-10 col-md-10">
                    <div class="offers_1">Offer Ends Today</div>
                    <h5>${product_show.title}</h5>
                  </div>
                  <div class="col-2 col-md-2" style="text-align:right!important;padding-left:0px;">`;
                if (product_show.compare_at_price > product_show.price)
                  product_show_html += `<span class="price_cut">${product_show.compare_at_price / 100}</span><Br/>`;
                product_show_html += `<span class="price_1">${product_show.price / 100}</span>
                  </div>
                </div>
              </div>
            </div>
           <div class="white_bg ${product_show.handle}" style="display:none">
             <div class="row align-items-center">
                `;
                var i = 0;
                var select_option = '';
                product_show.options.forEach(function (option) {
                  if (option.name != 'Title') {
                    var select = '<b>' + option.name + ':</b><div class="variant-selector"><select id="' + product_show.handle + '_option[' + i + ']" name="' + option.name + '">';
                    var counter_print = 1;
                    option.values.forEach(function (value) {
                      if (counter_print <= max_options)
                        select += '<option value="' + value + '">' + value + '</option>';
                      counter_print++;
                    });
                    select += '</select> </div>';
                    i++;
                    select_option += select;
                  }
                });
                if (select_option != '') {
                  product_show_html += '<div class="col-12 col-md-8 col-lg-8">' + select_option + '</div>';
                } else {
                  product_show_html += '<div class="col-12 col-md-4 col-lg-4 bundle_btn"></div>';
                }
                product_show_html += `<div class="col-12 col-md-4 col-lg-4 bundle_btn">                
               <button product="${product_show.handle}" id="c_${product_show.handle}"  type="button"   class="btn bundle_products_btn 
               `;
                if (in_cart !== -1)
                  product_show_html += "in_cart";
                product_show_html += `" style="font-size: 0.8em;">
                 <span class="">`;
                if (in_cart !== -1)
                  product_show_html += remove_product_text;
                else
                  product_show_html += add_to_cart_text;
                product_show_html += `</span>
               </button>
               </div>
             </div>
           </div>
          </div>
     </div>`;
                var j = '';
                if (in_cart !== -1)
                  j += ' checked="checked" ';
                $('#bundle_product_list_body').append(product_show_html);
              }
            });
          }
          if ($('#is_checkout_page').val() != 1) {
            $.each(checkbox_products, function (index, value) {
              var product_show = fetchProductByVariant(value);
              if (product_show.id > 0) {
                var in_cart = cart_variants.indexOf(product_show.variants[0].id);
                checkbox_products_html += `<div class="add_on_product-container ">
                      <div class="add_on_product-container_main">
                        <div>
                          <img src="${product_show.images[0].src}" style="width:50px; border-radius: 0%;" alt="${product_show.title}">
                        </div>
                        <div>
                          <div class="shipping-protection-title">${product_show.title} <span style="font-size: smaller;margin-left:5px">$j${product_show.variants[0].price}</span></div>
                          <div class="shipping-protection-text">${product_show.body_html}</div>
                        </div>
                      </div>
                      <div class="add_on_product-checkbox">
                      <input type="checkbox" id="pro_${product_show.handle}" value="${product_show.variants[0].id}" `;
                if (in_cart !== -1) {
                  checkbox_products_html += ' checked="" ';
                }
                checkbox_products_html += ` onchange="custom_add_remove('pro_${product_show.handle}')">
            <label for="pro_${product_show.handle}" class="toggle-switch"></label>
                      </div>
                    </div>`;
              }
            });
          }
          if (checkbox_products_html == '')
            $('.crm_drawer_cart_inner3').remove('');
          else
            $('.crm_drawer_cart_inner3').html(checkbox_products_html);
        } else {}
        $.each(checkbox_products, function (index, variant_id) {
          var in_cart = cart_variants.indexOf(String(variant_id));
          if (in_cart == -1) {
            $('input[type="checkbox"][value="' + variant_id + '"]').prop('checked', false);
          } else {
            $('input[type="checkbox"][value="' + variant_id + '"]').prop('checked', true);
          }
        });
        $.each(featured_products, function (index, handle) {
          var in_cart = cart_handles.indexOf(handle);
          if (in_cart == -1) {
            $('button[product="' + handle + '"]').removeClass('in_cart');
            $('button[product="' + handle + '"]').find('span').html(add_to_cart_text);
          } else {
            $('button[product="' + handle + '"]').addClass('in_cart');
            $('button[product="' + handle + '"]').find('span').html(added_product_text);
          }
        });
        $.each(bundle_products, function (index, handle) {
          var in_cart = cart_handles.indexOf(handle);
          if (in_cart == -1) {
            $('button[product="' + handle + '"]').removeClass('in_cart');
            $('button[product="' + handle + '"]').find('span').html(add_to_cart_text);
          } else {
            $('button[product="' + handle + '"]').addClass('in_cart');
            $('button[product="' + handle + '"]').find('span').html(remove_product_text);
          }
        });
        $('#crm_overlay').hide();
        console.log('update cart compelete');
        if (need_toggleDrawer == 1) {
          $('#crm_drawer').addClass("open");
          $('#crm_drawer').attr("aria-hidden", false);
          $('#crm_overlay_side').show();
          //toggleDrawer();
        }
        if ($('#is_checkout_page').val() == 1) {
          loadCart();
          refresh_price();
        }
      }
    }
  });
}

function checkBundleExists() {
  // Check if an element with the class 'kaching-bundles__bars' exists
  const elementExists = document.querySelector('.kaching-bundles__bars') !== null;
  // Log the result to the console
  console.log('Element exists:', elementExists);
  // You can also perform actions based on whether the element exists
  if (!elementExists) {
    $(".product-page-price").show();
  }
}

function fetchProductByVariant(variantId) {
  var result = '';
  $.ajax({
    url: '/products.json',
    method: 'GET',
    async: false,
    success: function (response) {
      $.each(response.products, function (index, product) {
        $.each(product.variants, function (i, variant) {
          if (variant.id == variantId) {
            result = product;
          }
        });
      });
    },
    error: function (error) {
      console.log("Error fetching products: ", error);
    }
  });
  return result;
}

function fetchProductByHandle(productHandle) {
  var result = '';
  $.ajax({
    url: '/products/' + productHandle + '.js',
    method: 'GET',
    async: false,
    dataType: 'json',
    success: function (response) {
      result = response;
    },
    error: function (error) {
      console.log("Error fetching products: ", error);
    }
  });
  return result;
}

function crm_update_qty(variant_id, qty_action) {
  var qty = $('#qty_' + variant_id).val();
  if (qty_action == '-1')
    qty--;
  else
    qty++;
  var formData = {
    'id': variant_id,
    'quantity': qty
  };
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: formData,
    dataType: 'json',
    cache: false,
    async: false,
    success: function () {
      updateCartDrawer();
    }
  });
}

function findVariantId(product, option1Value, option2Value) {
  var variantId = null;
  product.variants.forEach(function (variant) {
    if (variant.option1 === option1Value && (!option2Value || variant.option2 === option2Value)) {
      variantId = variant.id;
      return;
    }
  });
  return variantId;
}

function check_undefined(value) {
  if (typeof value === "undefined") {
    return '';
  } else
    return value;
}

function add_to_cart_frequently(but_ref, key, add_to_cart) {
  var variant_id = '';
  $.ajax({
    type: 'GET',
    url: '/products/' + $('#frequently-product-id' + key).val() + '.js',
    dataType: 'json',
    success: function (product) {
      variant_id = findVariantId(product, check_undefined($('#select-one' + key).val()), check_undefined($('#select-two' + key).val()))
      if (add_to_cart == 1) {
        var serializedData = '';
        serializedData += '&id=' + variant_id;
        serializedData += '&quantity=1';
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: serializedData,
          dataType: 'json',
          success: function () {
            var id = $(but_ref).attr("id");
            $("#" + id + '_exist').show();
            $("#" + id).hide();
            var cartDrawer = new theme.CartDrawer;
            cartDrawer.cartForm.buildCart();
          },
          error: function () {}
        });
      }
    },
    error: function (xhr, status, error) {
      console.error('Error fetching product:', status, error);
    }
  });
}

function update_frequently_products() {
  var key = $('#frequently-product-id1').val();
  if (check_id_exist(key) != "") {
    $("#" + key + '_id_exist').hide();
    $("#" + key + '_id').show();
  }
  var key = $('#frequently-product-id2').val();
  if (check_id_exist(key) != "") {
    $("#" + key + '_id_exist').hide();
    $("#" + key + '_id').show();
  }
}

function custom_add_remove_with_handle_new(handle, need_action) {
  var variant_options = [];
  // Collect all selected values for options
  $('select[id^="' + handle + '_option"]').each(function () {
    variant_options.push($(this).val());
  });
  var cart_variants = [];
  if (need_action == 0) {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      async: false,
      success: function (cart) {
        $.each(cart.items, function (index, item) {
          cart_variants.push(item.variant_id);
        });
      }
    });
  }
  // Fetch product data (assuming this is an async function returning a promise)
  var product = fetchProductByHandle(handle);
  var variant_found = null;
  // Loop through each variant to find a match
  product.variants.forEach(function (variant) {
    if (need_action == 0) {
      var in_cart = cart_variants.indexOf(variant.id);
      if (in_cart !== -1)
        drawer_change_qty(variant.id, 0, false);
    }
    var match_count = 0;
    // Check each selected option value against the variant's options
    variant_options.forEach(function (value, index) {
      var opno = 'option' + (index + 1); // option1, option2, etc.
      if (variant[opno] === value) {
        match_count++;
      }
    });
    // If all selections match, we found our variant
    if (match_count === variant_options.length) {
      variant_found = variant;
    }
  });
  // Handle case where no variant is found
  if (!variant_found) {
    //alert("No matching variant found.");
  } else {
    if (need_action == 1) {
      //Adding Product 
      addToCartFunction_CRM_drawer(variant_found.id, 1, 1);
    }
  }
  updateCartDrawer();
}

function check_id_exist(key) {
  var result = '';
  $.ajax({
    url: '/cart.js',
    dataType: "json",
    async: false,
    success: function (cart) {
      $.each(cart.items, function (index, item) {
        if (item.handle == key)
          result = item.key;
      });
    },
    error: function (error) {
      console.error("Error:", error);
    }
  });
  return result;
}

function addToCartFunction_CRM_drawer(variant_id, qty, stop_next = 0) {

  let formData = {
    'items': [{
      'id': variant_id,
      'quantity': qty
    }]
  };

  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(response) {
        if (stop_next == 0) {
          auto_add_checkbox_products_call();
        }
        resolve(response);
      },
      error: function(error) {
        reject(error);
      }
    });
  });





  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    async: false,
    success: function () {
      
      if (stop_next == 0)
        
        auto_add_checkbox_products_call();
      }
    });
  }
  
  function auto_add_checkbox_products_call() {
    console.log('auto_add_checkbox_products_call button_type_clicked', button_type_clicked);
    var openCartDrawerFlag = 1;
    if (button_type_clicked == "Guest") {
      openCartDrawerFlag = 0;
      window.location.href = "/pages/checkout-3";
      return;
    }
  if (auto_add_checkbox_products == true) {
    $.getJSON('/cart.json', function (cart) {
      if (cart.items.length == 1) {
        console.log('auto_add_checkbox_products', auto_add_checkbox_products);
        if (auto_add_checkbox_products == true) {
          $.each(auto_add_product, function (index, variant_id) {
            console.log('adding', variant_id);
            addToCartFunction_CRM(variant_id, 1, 1);
            $('input[type="checkbox"][value="' + variant_id + '"]').prop('checked', true);
          });
          auto_add_checkbox_products = false;
        }
        updateCartDrawer(openCartDrawerFlag);
      } else
        updateCartDrawer(openCartDrawerFlag);
    });
  } else {
    updateCartDrawer(openCartDrawerFlag);
  }
}

function drawer_change_qty(variant_id, qty, line) {
  if (line == true) {
    var formData = {
      'line': variant_id,
      'quantity': qty
    };
  } else {
    var formData = {
      'id': variant_id,
      'quantity': qty
    };
  }
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: formData,
    dataType: 'json',
    cache: false,
    async: false,
    success: function () {}
  });``
}

function clearGuestProduct() {
  $.ajax({
    url: '/cart.js',
    dataType: "json",
    cache: false,
    async: false,
    success: function (cart) {
      Shopify.queue = [];
      $.each(cart.items, function (index, item) {
        console.log(item.variant_options);
        if ($.inArray('Guest Price', item.variant_options) !== -1) {
          console.log(" item cleared ");
          var data = 'id=' + item.variant_id + '&quantity=0'
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            async: false,
            data: data,
            success: function (res) {
              console.log("removed ", item.variant_id, res);
            },
          });
        }
      });
      setTimeout(function () {
        updateCartDrawer(0, 0);
      }, 1000);
    }
  });
} 